export default __webpack_public_path__ + "static/media/H1006.3.7d61b864.mp3";